import logoBT from "@assets/logo-masthead.svg";
import logoUOB from "@assets/logo-uob-blue.png";
import { BlockTitle } from "@blocks/Blocks";
import Container from "@components/Container/Container";

/**
 * Component to render Organiser Details of SIA on homepage
 */
const SIAOrganiserDetails = (): React.ReactElement => {
  return (
    <Container
      rootClassName="font-public-sans text-gray-850"
      data-testis="sia-organiser-details-component"
    >
      <BlockTitle
        text="Jointly organised by"
        rootClassName="text-center mb-2 mt-12"
      />

      <div className="flex flex-col items-center justify-center px-3 pb-10 pt-2 md:flex-row md:px-6 lg:px-12">
        <img
          src={logoBT}
          width={211}
          alt="The Business Times logo"
          className="my-6 md:mx-18"
        />

        <img src={logoUOB} width={141} alt="UOB logo" className="mx-18 my-6" />
      </div>
    </Container>
  );
};

export default SIAOrganiserDetails;
